<template>
  <div class="user-add-container">
    <div class="back">
      <span @click="$router.go(-1)"
        ><i class="iconfont icon-back"></i>返回</span
      >
    </div>
    <div class="content">
      <div class="title">基本信息</div>
      <div class="box">
        <div class="avatar">
          <div class="img">
            <el-upload
              class="upload-demo"
              :action="URL + '/data/upload'"
              :show-file-list="false"
              :headers="{ Authorization: 'bearer' + token }"
              :on-success="handleAvatarSuccess"
              :limit="1"
            >
              <img v-if="data.photo" :src="data.photo" alt="" />
              <img v-else src="@/assets/images/avatar-defult.jpg" alt="" />
            </el-upload>
          </div>
        </div>
        <div class="form">
          <el-form ref="form" :rules="rules" :model="data" label-width="160px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="真实姓名" prop="name">
                  <el-input v-model="data.name" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="密码" prop="password">
                  <el-input
                    v-model="data.password"
                    show-password
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="所属公司" prop="belong_company">
                  <!-- <el-input v-model="data.company" placeholder="请输入"></el-input> -->
                  <el-select
                    v-model="data.belong_company"
                    filterable
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in options.companyOptions"
                      :key="item.company_id"
                      :label="item.company_name"
                      :value="item.company_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="员工编号">
                  <el-input
                    v-model="data.employee_num"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司地址">
                  <el-input
                    v-model="data.company_address"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="phone">
                  <el-input
                    v-model="data.phone"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="部门名称">
                  <el-input
                    v-model="data.department"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="座机">
                  <el-input
                    v-model="data.landline"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="岗位名称">
                  <el-input v-model="data.job" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮箱">
                  <el-input
                    v-model="data.email"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row :gutter="20">
              <el-form-item label="权限">
                <el-checkbox-group v-model="data.role">
                  <el-checkbox label="全部系统权限"></el-checkbox><br/>
                  <el-checkbox label="查看所属车辆信息"></el-checkbox><br/>
                  <el-checkbox label="维护车辆基础信息"></el-checkbox>
                </el-checkbox-group>
                <el-checkbox v-model="data.role1">全部系统权限</el-checkbox><br/>
                <el-checkbox v-model="data.role2">查看所属车辆信息</el-checkbox><br/>
                <el-checkbox v-model="data.role3">维护车辆基础信息</el-checkbox>
              </el-form-item>
            </el-row> -->
          </el-form>
          <div class="btns">
            <el-button type="primary" @click="submitForm('form')"
              >保存信息</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetRoleList, SetUserDeatil, GetUserPersonal } from '@/api/user'
import { isPhone } from '@/utils/validate'
import { getToken } from '@/utils/auth'
import { selectCompanyData } from '@/api/company'
export default {
  data () {
    return {
      id: null,
      token: getToken(),
      data: {
        // role:[],
        photo: '',
      },
      rules: {
        role_id: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入', trigger: 'blur' },
          { pattern: isPhone, message: '请输入正确的手机号!' },
        ],
        dept: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        landline: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        post: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
      
      },
      options: {
        type: [],
        companyOptions: []
      },
      URL: process.env.VUE_APP_BASE_API
    }
  },
  created () {
    this.id = this.$route.query.id
    this.getRoleData()
    this.getData()
    this.initCompanyData()
  },
  methods: {
    getRoleData () {
      GetRoleList()
        .then(res => {
          this.options.type = res.data
        })
    },
    handleAvatarSuccess (res) {
      if (res.code === 0) {
        this.data.photo = res.data.src
      }
    },
    getData () {
      const params = { id: '' }
      GetUserPersonal(params)
        .then(res => {
        // console.log(res)
        this.id=res.id
          res.data.password = "";
          if (res.data.belong_company != null && res.data.belong_company != '') {
            res.data.belong_company = Number(res.data.belong_company)
          }
          this.data = res.data

        })
    },
    //获取公司树数据
    initCompanyData () {
      selectCompanyData().then(res => {
        this.companyData = res.data
        this.initCompanySelectData();
      })
    },
    initCompanySelectData () {
      this.companyData.forEach(el => {
        this.options.companyOptions.push(el)
      })

    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.data.id = this.id
          this.data.personal = "1";
          SetUserDeatil(this.data).then(res => {
            if (res.code == 0) {
           const  user=JSON.parse( localStorage.user )
           user.name=this.data.name
              localStorage.user = JSON.stringify(user);
              this.$message.success('保存成功!')
              this.$router.back(-1)
            } else if (res.code == 1002) {
              this.$message.error('保存失败,用户名重复!')
            } else {
              this.$message.error('保存失败,用户信息错误!')
            }
          })
        } else {
          //console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.user-add-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .back {
    color: #42a3df;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
    span {
      cursor: pointer;
    }
    .iconfont {
      margin-right: 10px;
    }
  }
  .content {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px 20px;
    background: #fff;
    box-shadow: 0 0 6px 1px #acacac;
    overflow-y: auto;
    .title {
      font-size: 18px;
      line-height: 40px;
      font-weight: bold;
      color: #1f7eb8;
    }
    .box {
      display: flex;
      padding-top: 30px;
      .btns {
        padding: 30px 160px 60px;
      }
      .avatar {
        .img {
          padding: 30px 10px;
          border: 1px solid #bbb;
          img {
            width: 156px;
            height: 159px;
            display: block;
          }
        }
      }
      .form {
        flex: 1;
        min-width: 0;
        max-width: 1100px;
      }
    }
  }
  #map-container {
    width: 100%;
    height: 400px;
    box-shadow: 0 0 10px 1px #acacac;
  }
}
</style>
<style lang="less">
.equipment-add-container {
  .el-form-item__label {
    color: #1a2550;
    padding: 0 30px 0 0;
  }
  .el-select,
  .el-input {
    width: 100%;
  }
}
</style>
